import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/**
 * DESIGN_SYSTEM.md §4 / PRODUCT_FLOW.md cross-cutting states: an empty state
 * pairs a light icon treatment with exactly ONE concrete next action — never a
 * bare "No data available."
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon: IconName;
  title: string;
  description: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="emptystate">
      <span className="emptystate__icon">
        <Icon name={icon} size={24} />
      </span>
      <h2 className="emptystate__title">{title}</h2>
      <p className="emptystate__body">{description}</p>
      {action && <div className="emptystate__action">{action}</div>}
    </div>
  );
}
